import { render } from "./NameGenerationStep.vue?vue&type=template&id=5b931c10"
import script from "./NameGenerationStep.vue?vue&type=script&lang=js"
export * from "./NameGenerationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__